import { ListChecks } from 'lucide-react';
import { useSelector } from 'react-redux';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';
import { getStatuses } from 'store/v1/statuses/statuses.selectors';
import * as entityTypes from 'v1/helpers/entityTypes';
import { rd } from '@passionware/monads';

export type ProductionStatusValue = number;

// Define icon at module level to avoid creating JSX inside hook callbacks
const statusIcon = <ListChecks className="size-4" />;

export function createProductionStatusFilterConfig(): FilterEnumConfig<ProductionStatusValue> {
  const useStatusOptions = (query: string) => {
    const productionStatuses = useSelector((state: any) =>
      (getStatuses as any)(state, { entity_type: entityTypes.PRODUCTION })
    );

    const statusDisplayValues = productionStatuses.map(
      (status: { id: number; name: string }) => ({
        value: status.id,
        label: status.name
      })
    );

    const normalizedQuery = query.trim().toLowerCase();
    const filtered = statusDisplayValues.filter((s: { label: string }) =>
      s.label.toLowerCase().includes(normalizedQuery)
    );
    return rd.of(filtered);
  };

  const useStatusValues = (values: ProductionStatusValue[]) => {
    const productionStatuses = useSelector((state: any) =>
      (getStatuses as any)(state, { entity_type: entityTypes.PRODUCTION })
    );

    const statusDisplayValues = productionStatuses.map(
      (status: { id: number; name: string }) => ({
        value: status.id,
        label: status.name
      })
    );

    return rd.of(
      statusDisplayValues.filter((s: { value: number }) =>
        values.includes(s.value)
      )
    );
  };

  return {
    label: 'Status',
    icon: statusIcon,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] }),
    options: {
      useValues: useStatusValues,
      useOptions: useStatusOptions
    }
  };
}
